import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { getOwner } from '@ember/application';
import { ComposerNewsletterTemplate, createComposerEditableEntity } from 'cio/utils/composer/composer-editable-entity';
import NewsletterModel from 'cio/models/newsletter';
import TemplateModel from 'cio/models/template';

export default class BroadcastsNewsletterOverviewContentIndexController extends Controller {
  queryParams = ['templateId'];
  templateId?: string;

  @computed('model.templates.[]', 'templateId')
  get editableEntity(): ComposerNewsletterTemplate {
    let newsletter = this.model as NewsletterModel;
    let template = isEmpty(this.templateId)
      ? newsletter.templates.firstObject
      : (newsletter.templates.content as TemplateModel[]).find((t) => t.id === this.templateId);

    return createComposerEditableEntity(getOwner(this), {
      newsletter,
      template,
    }) as ComposerNewsletterTemplate;
  }

  setDefaults() {
    this.set('templateId', undefined);
  }
}
